import { createSlice } from '@reduxjs/toolkit';
import { fetchAllEventsThunk } from '../thunks/crmEventsThunks';

const initialState = {
  recentMessages: [],
  calls: [],
  missedCalls: [],
  loading: false,
  error: null,

  filters: {
    search: '',
    type: 'all',
    contactType: 'all', // 'all' | 'leads' | 'patients' | 'unknown'
  },
};

const crmEventsSlice = createSlice({
  name: 'crmEvents',
  initialState,
  reducers: {
    setRecentMessages: (state, action) => {
      state.recentMessages = action.payload;
    },
    setCalls: (state, action) => {
      state.calls = action.payload;
    },
    setMissedCalls: (state, action) => {
      state.missedCalls = action.payload;
    },
    markEventRead: (state, action) => {
      const { type, id } = action.payload;
      let array;

      switch (type) {
        case 'message':
          array = state.recentMessages;
          break;
        case 'call':
          array = state.calls;
          break;
        case 'missedCall':
          array = state.missedCalls;
          break;
        default:
          return;
      }

      const event = array.find(e => e.id === id);
      if (event) {
        event.read = true;
      }
    },
    setSearch: (state, action) => {
      state.filters.search = action.payload;
    },
    setTypeFilter: (state, action) => {
      state.filters.type = action.payload;
    },
    setContactFilter: (state, action) => {
      state.filters.contactType = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchAllEventsThunk
      .addCase(fetchAllEventsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllEventsThunk.fulfilled, (state, action) => {
        state.recentMessages = action.payload.recentMessages || [];
        state.calls = action.payload.calls || [];
        state.missedCalls = action.payload.missedCalls || [];
        state.loading = false;
      })
      .addCase(fetchAllEventsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setRecentMessages,
  setCalls,
  setMissedCalls,
  markEventRead,
  setSearch,
  setTypeFilter,
  setContactFilter,
  resetFilters,
} = crmEventsSlice.actions;

export default crmEventsSlice.reducer;
